import { atom } from "recoil";

const menuAtom = atom({

    key:"menuState",
    default:false

});

export default menuAtom;